export default 'tizenwatch';
